import { type BasePage, BasePageURL } from "@/constants/site-builder";
import { removeRedundantSlashFromPath } from "./removeRedundantSlashFromPath";

export function createSiteBasePageURL(basePage: BasePage, pathname: string) {
  return removeRedundantSlashFromPath(
    ["/", BasePageURL[basePage], pathname].join("/"),
  );
}
